var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "service-autocomplete",
    _vm._b(
      {
        ref: "autocomplete",
        attrs: {
          "search-attributes-array": ["name", "author_original_id"],
          value: _vm.value,
          url: _vm.url,
          "cache-items": "",
          multiple: "",
          "use-entities": false,
          baseAndQueryParams: _vm.queryParams
        },
        on: { input: _vm.handleInputChange },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c(
                  "v-list-item-avatar",
                  {
                    staticClass: "font-weight-light white--text",
                    attrs: { color: "primary" }
                  },
                  [_vm._v("\n      " + _vm._s(item.organisation) + "\n    ")]
                ),
                _vm._v(" "),
                _c(
                  "v-list-item-content",
                  [
                    _c("v-list-item-title", [
                      _vm._v(
                        "\n        " +
                          _vm._s(item.name + " - " + item.author_original_id) +
                          "\n      "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-list-item-action", [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.generateMessage(`authors.type.${item.type}`)) +
                      "\n    "
                  )
                ])
              ]
            }
          },
          {
            key: "selection",
            fn: function({ attrs, selected, item }) {
              return [
                _c(
                  "v-chip",
                  _vm._b(
                    {
                      attrs: { value: selected, close: "", small: "" },
                      on: {
                        "click:close": function($event) {
                          return _vm.$refs.autocomplete.handleInputRemove(item)
                        }
                      }
                    },
                    "v-chip",
                    attrs,
                    false
                  ),
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          item.name +
                            " (" +
                            _vm.generateMessage(`authors.type.${item.type}`) +
                            ")"
                        ) +
                        "\n    "
                    )
                  ]
                )
              ]
            }
          }
        ])
      },
      "service-autocomplete",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }